export default from './ForgotPasswordForm';



// WEBPACK FOOTER //
// ./src/sharedComponents/ForgotPasswordForm/index.js